/** Countries a branch can be in, each with the time zone to suggest first. ISO 3166-1 alpha-2. */
export interface Country {
  code: string;
  name: string;
  timeZone: string;
}

export const COUNTRIES: readonly Country[] = [
  { code: 'KE', name: 'Kenya', timeZone: 'Africa/Nairobi' },
  { code: 'UG', name: 'Uganda', timeZone: 'Africa/Kampala' },
  { code: 'TZ', name: 'Tanzania', timeZone: 'Africa/Dar_es_Salaam' },
  { code: 'RW', name: 'Rwanda', timeZone: 'Africa/Kigali' },
  { code: 'BI', name: 'Burundi', timeZone: 'Africa/Bujumbura' },
  { code: 'ET', name: 'Ethiopia', timeZone: 'Africa/Addis_Ababa' },
  { code: 'SO', name: 'Somalia', timeZone: 'Africa/Mogadishu' },
  { code: 'SS', name: 'South Sudan', timeZone: 'Africa/Juba' },
  { code: 'NG', name: 'Nigeria', timeZone: 'Africa/Lagos' },
  { code: 'GH', name: 'Ghana', timeZone: 'Africa/Accra' },
  { code: 'ZA', name: 'South Africa', timeZone: 'Africa/Johannesburg' },
  { code: 'ZM', name: 'Zambia', timeZone: 'Africa/Lusaka' },
  { code: 'ZW', name: 'Zimbabwe', timeZone: 'Africa/Harare' },
  { code: 'MW', name: 'Malawi', timeZone: 'Africa/Blantyre' },
  { code: 'MZ', name: 'Mozambique', timeZone: 'Africa/Maputo' },
  { code: 'BW', name: 'Botswana', timeZone: 'Africa/Gaborone' },
  { code: 'NA', name: 'Namibia', timeZone: 'Africa/Windhoek' },
  { code: 'CD', name: 'DR Congo', timeZone: 'Africa/Kinshasa' },
  { code: 'EG', name: 'Egypt', timeZone: 'Africa/Cairo' },
  { code: 'MA', name: 'Morocco', timeZone: 'Africa/Casablanca' },
  { code: 'SN', name: 'Senegal', timeZone: 'Africa/Dakar' },
  { code: 'CI', name: "Côte d'Ivoire", timeZone: 'Africa/Abidjan' },
  { code: 'AE', name: 'United Arab Emirates', timeZone: 'Asia/Dubai' },
  { code: 'IN', name: 'India', timeZone: 'Asia/Kolkata' },
  { code: 'GB', name: 'United Kingdom', timeZone: 'Europe/London' },
  { code: 'US', name: 'United States', timeZone: 'America/New_York' },
];

const BY_CODE = new Map(COUNTRIES.map((c) => [c.code, c]));

export function countryName(code: string | null | undefined): string | null {
  return code ? (BY_CODE.get(code.toUpperCase())?.name ?? code) : null;
}

export function isCountryCode(code: string): boolean {
  return BY_CODE.has(code.toUpperCase());
}

export function countryTimeZone(code: string): string | null {
  return BY_CODE.get(code.toUpperCase())?.timeZone ?? null;
}
